import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-brand hover:underline font-heading font-bold text-sm uppercase tracking-wider mb-8" data-testid="privacy-back-link">
          <ArrowLeft className="w-4 h-4" /> Retour a l'accueil
        </Link>

        <h1 className="font-heading text-3xl md:text-4xl font-black uppercase tracking-tight mb-2">Politique de Confidentialite</h1>
        <p className="text-slate-400 text-sm mb-12">Derniere mise a jour : Mars 2026</p>

        <div className="prose prose-slate max-w-none space-y-8 text-sm leading-relaxed">

          <section>
            <h2 className="font-heading text-lg font-bold uppercase tracking-wider border-b border-slate-200 pb-2 mb-4">1. Responsable du traitement</h2>
            <p>Le responsable du traitement des donnees personnelles collectees sur la plateforme <strong>iBookSport</strong> est :</p>
            <ul className="list-disc pl-6 space-y-1 text-slate-600">
              <li>Societe : <strong>WEBISULA</strong></li>
              <li>Siege social : Route des Sanguinaires, 20000 Ajaccio, France</li>
              <li>SIRET : 45138736900031</li>
              <li>Email : <Link to="/contact" className="text-brand hover:underline font-bold">Contactez-nous</Link></li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg font-bold uppercase tracking-wider border-b border-slate-200 pb-2 mb-4">2. Donnees collectees</h2>
            <p>Dans le cadre de l'utilisation de la plateforme iBookSport, nous sommes amenes a collecter les donnees personnelles suivantes :</p>
            <h3 className="font-heading font-bold text-sm uppercase mt-4 mb-2">2.1 Donnees d'identification</h3>
            <ul className="list-disc pl-6 space-y-1 text-slate-600">
              <li>Nom et prenom</li>
              <li>Adresse email</li>
              <li>Numero de telephone (optionnel)</li>
              <li>Adresse postale (pour les organisateurs et partenaires)</li>
              <li>Nom de l'entreprise/association (pour les organisateurs et partenaires)</li>
            </ul>
            <h3 className="font-heading font-bold text-sm uppercase mt-4 mb-2">2.2 Donnees liees aux inscriptions</h3>
            <ul className="list-disc pl-6 space-y-1 text-slate-600">
              <li>Date de naissance</li>
              <li>Sexe</li>
              <li>Categorie sportive</li>
              <li>Numero de licence sportive (le cas echeant)</li>
              <li>Certificat medical (upload)</li>
              <li>Contact d'urgence</li>
              <li>Taille de t-shirt et preferences de dotation</li>
            </ul>
            <h3 className="font-heading font-bold text-sm uppercase mt-4 mb-2">2.3 Donnees de paiement</h3>
            <ul className="list-disc pl-6 space-y-1 text-slate-600">
              <li>Les donnees bancaires ne sont <strong>jamais stockees</strong> sur nos serveurs. Elles sont traitees directement par notre prestataire de paiement securise conforme PCI-DSS.</li>
              <li>Historique des transactions (montant, date, reference)</li>
            </ul>
            <h3 className="font-heading font-bold text-sm uppercase mt-4 mb-2">2.4 Donnees techniques</h3>
            <ul className="list-disc pl-6 space-y-1 text-slate-600">
              <li>Adresse IP</li>
              <li>Type de navigateur et systeme d'exploitation</li>
              <li>Pages visitees et duree de la visite</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg font-bold uppercase tracking-wider border-b border-slate-200 pb-2 mb-4">3. Finalites du traitement</h2>
            <p>Les donnees personnelles sont collectees pour les finalites suivantes :</p>
            <ul className="list-disc pl-6 space-y-1 text-slate-600">
              <li>Gestion des comptes utilisateurs et authentification</li>
              <li>Traitement des inscriptions aux evenements sportifs</li>
              <li>Traitement des paiements et generation des factures et recus fiscaux</li>
              <li>Communication entre les organisateurs et les participants (notifications, emails transactionnels)</li>
              <li>Gestion de la boutique personnalisee et des commandes de produits</li>
              <li>Gestion des abonnements partenaires</li>
              <li>Amelioration de la plateforme et statistiques anonymisees</li>
              <li>Respect des obligations legales et reglementaires</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg font-bold uppercase tracking-wider border-b border-slate-200 pb-2 mb-4">4. Base legale du traitement</h2>
            <p>Le traitement des donnees est fonde sur :</p>
            <ul className="list-disc pl-6 space-y-1 text-slate-600">
              <li><strong>L'execution d'un contrat :</strong> inscription a un evenement, creation de compte, gestion des commandes.</li>
              <li><strong>Le consentement :</strong> envoi de newsletters et communications promotionnelles.</li>
              <li><strong>L'obligation legale :</strong> conservation des donnees de facturation, generation de recus fiscaux.</li>
              <li><strong>L'interet legitime :</strong> amelioration des services, securite de la plateforme, statistiques.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg font-bold uppercase tracking-wider border-b border-slate-200 pb-2 mb-4">5. Destinataires des donnees</h2>
            <p>Les donnees personnelles peuvent etre transmises aux destinataires suivants :</p>
            <ul className="list-disc pl-6 space-y-1 text-slate-600">
              <li><strong>Les organisateurs d'evenements :</strong> pour la gestion des inscriptions et le bon deroulement de l'evenement.</li>
              <li><strong>Les partenaires/prestataires :</strong> uniquement dans le cadre des commandes de produits ou services.</li>
              <li><strong>Les prestataires techniques :</strong> hebergement, paiement en ligne, envoi d'emails transactionnels. Ces prestataires sont contractuellement tenus de respecter la confidentialite des donnees.</li>
            </ul>
            <p className="mt-2"><strong>Aucune donnee personnelle n'est vendue a des tiers a des fins commerciales.</strong></p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-bold uppercase tracking-wider border-b border-slate-200 pb-2 mb-4">6. Duree de conservation</h2>
            <ul className="list-disc pl-6 space-y-1 text-slate-600">
              <li><strong>Donnees de compte :</strong> conservees pendant toute la duree d'activite du compte, puis 3 ans apres sa suppression.</li>
              <li><strong>Donnees d'inscription :</strong> conservees 3 ans apres l'evenement.</li>
              <li><strong>Donnees de facturation :</strong> conservees 10 ans conformement aux obligations comptables.</li>
              <li><strong>Donnees techniques (logs) :</strong> conservees 12 mois.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg font-bold uppercase tracking-wider border-b border-slate-200 pb-2 mb-4">7. Securite des donnees</h2>
            <p>WEBISULA met en oeuvre les mesures techniques et organisationnelles appropriees pour garantir la securite des donnees personnelles :</p>
            <ul className="list-disc pl-6 space-y-1 text-slate-600">
              <li>Chiffrement des communications (HTTPS/TLS)</li>
              <li>Hachage des mots de passe (bcrypt)</li>
              <li>Acces restreint aux donnees selon les roles (participant, organisateur, partenaire, administrateur)</li>
              <li>Sauvegardes regulieres des bases de donnees</li>
              <li>Paiements traites par un prestataire certifie PCI-DSS</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg font-bold uppercase tracking-wider border-b border-slate-200 pb-2 mb-4">8. Cookies</h2>
            <p>La plateforme iBookSport utilise des cookies strictement necessaires au fonctionnement du service :</p>
            <ul className="list-disc pl-6 space-y-1 text-slate-600">
              <li><strong>Cookies d'authentification :</strong> maintien de la session utilisateur.</li>
              <li><strong>Cookies de preferences :</strong> sauvegarde des parametres d'affichage.</li>
            </ul>
            <p className="mt-2">Aucun cookie publicitaire ou de tracking tiers n'est utilise.</p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-bold uppercase tracking-wider border-b border-slate-200 pb-2 mb-4">9. Vos droits (RGPD)</h2>
            <p>Conformement au Reglement General sur la Protection des Donnees (RGPD) et a la loi Informatique et Libertes, vous disposez des droits suivants :</p>
            <ul className="list-disc pl-6 space-y-1 text-slate-600">
              <li><strong>Droit d'acces :</strong> obtenir la confirmation du traitement de vos donnees et en obtenir une copie.</li>
              <li><strong>Droit de rectification :</strong> corriger vos donnees inexactes ou incompletes.</li>
              <li><strong>Droit a l'effacement :</strong> demander la suppression de vos donnees, sous reserve des obligations legales de conservation.</li>
              <li><strong>Droit a la limitation :</strong> demander la limitation du traitement dans certains cas.</li>
              <li><strong>Droit a la portabilite :</strong> recevoir vos donnees dans un format structure et lisible par machine.</li>
              <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos donnees pour des motifs legitimes.</li>
            </ul>
            <p className="mt-4">Pour exercer vos droits : <Link to="/contact" className="text-brand hover:underline font-bold">Contactez-nous</Link></p>
            <p>Nous nous engageons a repondre a votre demande dans un delai maximum de 30 jours.</p>
            <p className="mt-2">En cas de difficulte, vous pouvez introduire une reclamation aupres de la <strong>CNIL</strong> (Commission Nationale de l'Informatique et des Libertes) : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-brand hover:underline">www.cnil.fr</a></p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-bold uppercase tracking-wider border-b border-slate-200 pb-2 mb-4">10. Transfert de donnees hors UE</h2>
            <p>Les donnees personnelles sont hebergees sur des serveurs situes dans l'Union Europeenne. En cas de transfert vers un pays tiers, des garanties appropriees sont mises en place (clauses contractuelles types de la Commission Europeenne).</p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-bold uppercase tracking-wider border-b border-slate-200 pb-2 mb-4">11. Modification de la politique</h2>
            <p>WEBISULA se reserve le droit de modifier la presente politique de confidentialite a tout moment. Toute modification sera portee a la connaissance des utilisateurs par une mise a jour de cette page. La date de derniere mise a jour figure en haut du document.</p>
          </section>

          <section className="bg-slate-50 p-6 border border-slate-200 mt-12">
            <h2 className="font-heading text-lg font-bold uppercase tracking-wider mb-4">Contact</h2>
            <p className="text-slate-600">Pour toute question relative a la protection de vos donnees personnelles :</p>
            <ul className="list-disc pl-6 space-y-1 text-slate-600 mt-2">
              <li>Email : <Link to="/contact" className="text-brand hover:underline font-bold">Contactez-nous</Link></li>
              <li>Adresse : WEBISULA — Route des Sanguinaires, 20000 Ajaccio, France</li>
            </ul>
          </section>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
